import { createSelector } from '@reduxjs/toolkit';
import { flatten } from 'lodash';
import type { Rooms } from '@lt/api/dist/methods/search/types';
import { convertServerDateToClientDate } from '../../../../utils/dateUtils';
import { getRooms } from './rooms';
import { getSearchedNights } from './common';

export const getDatesWithPricesByFilter = createSelector(
  [getRooms, getSearchedNights],
  (rooms: Rooms, nightsCount: number) => {
    if (!rooms) {
      return null;
    }

    const cacheMap = new Map();

    rooms.forEach(({ offers }) => {
      const allOffers = flatten(Object.values(offers));
      const filteringOffersByNights = allOffers.filter(
        ({ nights_count }) => nights_count === nightsCount,
      );
      filteringOffersByNights.forEach((offer) => {
        const { start_date, price } = offer;

        const existed = cacheMap.get(start_date);
        const date = convertServerDateToClientDate(start_date);
        const pricePerNight = price
          ? Math.round(price / offer.nights_count)
          : 0;

        if (!existed || (existed && existed.price > price)) {
          cacheMap.set(start_date, {
            date,
            price,
            pricePerNight,
          });
        }
        if (existed && existed.pricePerNight > pricePerNight) {
          cacheMap.set(start_date, {
            ...cacheMap.get(start_date),
            pricePerNight,
          });
        }
      });
    });

    return Array.from(cacheMap.values());
  },
);
